import getMeta from './get_meta';

/**
 * Gets the visitor id from the meta tag
 */
export default function getVisitorId() {
  return getMeta('visitor-id') || getMeta('visitor_id');
}
